/**
 * 0.44.60 - Markdown to plain text, for =removemd(text) in expressions.
 *
 * The same rules as backend/app/services/markdown_plain.py (collection
 * Rich text columns: <key> is plain, <key>_md the Markdown); keep the
 * two in step.
 *
 * Kept: the words, line breaks, paragraph breaks. Removed: emphasis
 * markers (** __ * _ ~~), inline code backticks and code fences, heading
 * #, blockquote >, list markers (- * + 1. 1)), horizontal rules, HTML
 * tags. Images become their alt text (![alt](url) -> alt). A
 * backslash-escaped character stays as itself.
 *
 * 0.45.38 - A link keeps its address: [text](url) -> "text (url)", for
 * internal (/path) and external links alike, and a link whose text is
 * its address is the address once. The {: hyperlink="ext"} /
 * {: target="_blank"} suffix after a link is removed (it used to stay
 * in the text), with any space before it.
 */
const ESC = '\u0000';

export function stripMarkdown(text) {
  if (text === undefined || text === null) return '';
  let s = String(text).replace(/\r\n?/g, '\n');
  if (!s.trim()) return '';
  const escaped = [];
  s = s.replace(/\\([\\`*_{}[\]()#+\-.!>~|])/g, (_m, c) => {
    escaped.push(c);
    return `${ESC}${escaped.length - 1}${ESC}`;
  });
  s = s.replace(/^\s*(```|~~~).*$/gm, '');
  s = s.replace(/!\[([^\]]*)\]\([^)]*\)(?:[ \t]*\{:[^}\n]*\})?/g, '$1');
  s = s.replace(/\[([^\]]+)\]\(([^)\s]*)[^)]*\)(?:[ \t]*\{:[^}\n]*\})?/g,
    (_m, label, url) => (!url || label.trim() === url ? (url || label) : `${label} (${url})`));
  s = s.replace(/\[([^\]]+)\]\[[^\]]*\]/g, '$1');
  s = s.replace(/<[^>\n]+>/g, '');
  s = s.replace(/^\s{0,3}(?:[-*_]\s*){3,}$/gm, '');
  s = s.replace(/^\s{0,3}#{1,6}\s+/gm, '');
  s = s.replace(/\s+#+\s*$/gm, '');
  s = s.replace(/^\s{0,3}>\s?/gm, '');
  s = s.replace(/^\s*(?:[-*+]|\d{1,9}[.)])\s+/gm, '');
  s = s.replace(/`([^`\n]*)`/g, '$1');
  for (let i = 0; i < 2; i++) {
    s = s.replace(/(\*\*|__)(?=\S)(.+?)(?<=\S)\1/g, '$2');
    s = s.replace(/~~(?=\S)(.+?)(?<=\S)~~/g, '$1');
    s = s.replace(/(?<![\p{L}\p{N}_*])\*(?=\S)([^*\n]+?)(?<=\S)\*(?![\p{L}\p{N}_*])/gu, '$1');
    s = s.replace(/(?<![\p{L}\p{N}_])_(?=\S)([^_\n]+?)(?<=\S)_(?![\p{L}\p{N}_])/gu, '$1');
  }
  s = s.replace(/[ \t]+\n/g, '\n');
  s = s.replace(/\n{3,}/g, '\n\n');
  s = s.replace(new RegExp(`${ESC}(\\d+)${ESC}`, 'g'), (_m, n) => escaped[Number(n)]);
  return s.trim();
}
